import { PortalForm } from "../types/portal-form.interface";
import axios from "axios";
import m from "mithril";

const GET_UPLOAD_URL_ENDPOINT = `https://sahc-submission-portal.netlify.app/.netlify/functions/get-upload-url`;
const COMPLETE_UPLOAD_ENDPOINT = `https://sahc-submission-portal.netlify.app/.netlify/functions/complete-multi-part-upload`;

// 100 "MB"
// S3 has limits: between 5MB and 5GB
// Mobile browsers don't seem to handle reading files above ~300MB
const MULTI_PART_SIZE = 100_000_000;

export type GetUploadUrlRes = GetUploadUrlResSingle | GetUploadUrlResMulti;

export type GetUploadUrlResSingle = {
  uploadType: "single",
  signedUploadUrl: string,
};

export type GetUploadUrlResMulti = {
  uploadType: "multiple",
  uploadId: string,
  uploadPartCount: number,
  signedUploadUrls: {
    [x: number]: string,
  },
  objectKey: string,
};

type CompleteUploadBody = {
  objectKey: string,
  uploadId: string,
  uploadPartCount: number,
  partETags: { [x: number]: string },
};

export class UploadService {

  progress: string = "0%";

  constructor() { }

  async getUploadUrl(portalForm: PortalForm): Promise<undefined | GetUploadUrlRes> {

    try {

      const response = await fetch(GET_UPLOAD_URL_ENDPOINT, {
        method: "POST",
        body: JSON.stringify(portalForm),
      });
      const responseJson = await response.json();
      console.log("Response:", responseJson);

      return responseJson as GetUploadUrlRes;

    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  async uploadFileToUrl(file: File, url: string): Promise<boolean> {

    const fileBuffer = await file.arrayBuffer();
    const fileStream = file.stream();
    const fileSize = file.size;
    const fileType = file.type;

    const axiosRes = await axios.put(
      url,
      fileBuffer,
      // fileStream,
      {
        onUploadProgress: (ev: ProgressEvent) => {
          const progressRatio = Number((ev.loaded / ev.total).toFixed(2)) || 0;
          this.progress = (progressRatio * 100).toFixed(0) + "%";
          m.redraw();
        },
      },
    );
    const isOk = axiosRes.status.toString().startsWith("2");
    return isOk;

    // const res = await fetch(url, {
    //   method: "PUT",
    //   headers: {
    //     "Content-Type": file.type, // "application/octet-stream",
    //     "Content-Length": String(fileBuffer.byteLength),
    //   },
    //   body: fileBuffer,
    // });
    // return res;
  }

  async uploadFilePartsToUrls(file: File, urls: string[], multiUploadRes: GetUploadUrlResMulti): Promise<boolean> {

    const partETags: {
      [x: number]: string,
    } = {};

    for (let index = 0; index < urls.length; index++) {

      const uploadUrl = urls[index];

      const start = index * MULTI_PART_SIZE;
      const end = (index + 1) * MULTI_PART_SIZE;
      const fileChunk = end > file.size ? file.slice(start) : file.slice(start, end);

      try {

        const axiosRes = await axios.put(
          uploadUrl,
          fileChunk,
          // fileBuffer,
          // fileStream,
          {
            onUploadProgress: (ev: ProgressEvent) => {
              const progressRatio = Number((ev.loaded / ev.total).toFixed(2)) || 0;
              this.progress = `chunk ${index + 1} of ${urls.length} - ${(progressRatio * 100).toFixed(0)}%`;
              m.redraw();
            },
          },
        );
        const isOk = axiosRes.status.toString().startsWith("2");
        // return isOk;
        if (!isOk) {
          return false;
        }

        partETags[index] = axiosRes.headers.etag;

      } catch (error) {
        console.error(error);
        alert(`An error occurred while uploading your submission, please try again later.`);
      }

    }

    // Notify S3 to complete the multi-part upload
    const confirmComplete = await this.completeMultiPartUpload({
      objectKey: multiUploadRes.objectKey,
      uploadId: multiUploadRes.uploadId,
      uploadPartCount: multiUploadRes.uploadPartCount,
      partETags,
    })

    return confirmComplete;
  }

  async completeMultiPartUpload(upload: CompleteUploadBody) {

    try {

      const response = await fetch(COMPLETE_UPLOAD_ENDPOINT, {
        method: "POST",
        body: JSON.stringify(upload),
      });
      const responseJson = await response.json();
      console.log("Response:", responseJson);

      return true;
      // return responseJson as GetUploadUrlRes;

    } catch (error) {
      console.error(error);
      return false;
    }

  }

}
export const uploadSvc = new UploadService();
